import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  constrNo: null,
  siteNo: null,
  SEQ: null,
  siteLoc: null,

  task: null,
  visitDate: null,
  visitRptSedDate: null,
  detailedCmt: null,
};

export const siteVisitSlice = createSlice({
  name: "SiteVisit",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateSiteNo: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
      };
    },

    updasteSite: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
        siteLoc: action.payload.siteLoc,
      };
    },

    updateTask: (state, action) => {
      return {
        ...state,
        task: action.payload.task,
      };
    },

    updateVisitDate: (state, action) => {
      return {
        ...state,
        visitDate: action.payload.visitDate,
      };
    },

    updasteVisitRptSedDate: (state, action) => {
      return {
        ...state,
        visitRptSedDate: action.payload.visitRptSedDate,
      };
    },

    updateDetailedCmt: (state, action) => {
      return {
        ...state,
        detailedCmt: action.payload.detailedCmt,
      };
    },

    updateCmt: (state, action) => {
      return {
        ...state,
        cmt: action.payload.cmt,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
      };
    },
  },
});

export const {
  updateAction,
  init,
  updateSiteNo,
  updateTask,
  updateVisitDate,
  updasteVisitRptSedDate,
  updateDetailedCmt,
  updateCmt,
  updasteSite,
  updateAll,
} = siteVisitSlice.actions;

export default siteVisitSlice.reducer;
